import {
  FETCH_NAV_ATHLETES_START,
  FETCH_NAV_ATHLETES_FULFILLED,
  FETCH_NAV_ATHLETES_REJECTED,
  FETCH_NAV_ARCHIVED_ATHLETES_START,
  FETCH_NAV_ARCHIVED_ATHLETES_FULFILLED,
  FETCH_NAV_ARCHIVED_ATHLETES_REJECTED,
  FETCH_NAV_ATHLETE_ASSIGNMENTS_START,
  FETCH_NAV_ATHLETE_ASSIGNMENTS_FULFILLED,
  FETCH_NAV_ATHLETE_ASSIGNMENTS_REJECTED,
  FETCH_NAV_ATHLETE_CALENDARS_START,
  FETCH_NAV_ATHLETE_CALENDARS_FULFILLED,
  FETCH_NAV_ATHLETE_CALENDARS_REJECTED,
  FETCH_NAV_ATHLETE_PROGRAMS_START,
  FETCH_NAV_ATHLETE_PROGRAMS_FULFILLED,
  FETCH_NAV_ATHLETE_PROGRAMS_REJECTED,
  ASSIGN_NAV_ATHLETE_PROGRAMS_START,
  ASSIGN_NAV_ATHLETE_PROGRAMS_FULFILLED,
  ASSIGN_NAV_ATHLETE_PROGRAMS_REJECTED,
  DELETE_NAV_ATHLETE_PROGRAM_START,
  DELETE_NAV_ATHLETE_PROGRAM_FULFILLED,
  DELETE_NAV_ATHLETE_PROGRAM_REJECTED,
  RESTART_NAV_ATHLETE_PROGRAM_START,
  RESTART_NAV_ATHLETE_PROGRAM_FULFILLED,
  RESTART_NAV_ATHLETE_PROGRAM_REJECTED,
  FETCH_NAV_CALENDARS_START,
  FETCH_NAV_CALENDARS_FULFILLED,
  FETCH_NAV_CALENDARS_REJECTED,
  FETCH_NAV_CALENDAR_PREVIEW_START,
  FETCH_NAV_CALENDAR_PREVIEW_FULFILLED,
  FETCH_NAV_CALENDAR_PREVIEW_REJECTED,
  FETCH_NAV_CALENDAR_ITEMS_START,
  FETCH_NAV_CALENDAR_ITEMS_FULFILLED,
  FETCH_NAV_CALENDAR_ITEMS_REJECTED,
  FETCH_NAV_GROUPS_START,
  FETCH_NAV_GROUPS_FULFILLED,
  FETCH_NAV_GROUPS_REJECTED,
  FETCH_NAV_PROGRAMS_START,
  FETCH_NAV_PROGRAMS_FULFILLED,
  FETCH_NAV_PROGRAMS_REJECTED,
  FETCH_NAV_PROGRAM_ITEMS_START,
  FETCH_NAV_PROGRAM_ITEMS_FULFILLED,
  FETCH_NAV_PROGRAM_ITEMS_REJECTED,
  FETCH_NAV_PROGRAM_DAY_ONE_START,
  FETCH_NAV_PROGRAM_DAY_ONE_FULFILLED,
  FETCH_NAV_PROGRAM_DAY_ONE_REJECTED,
  FETCH_NAV_PROGRAM_PREVIEW_START,
  FETCH_NAV_PROGRAM_PREVIEW_FULFILLED,
  FETCH_NAV_PROGRAM_PREVIEW_REJECTED,
  FETCH_NAV_USER_START,
  FETCH_NAV_USER_FULFILLED,
  FETCH_NAV_USER_REJECTED,
  UPDATE_NAV_USER_START,
  UPDATE_NAV_USER_FULFILLED,
  UPDATE_NAV_USER_REJECTED,
  CREATE_NAV_USER_START,
  CREATE_NAV_USER_FULFILLED,
  CREATE_NAV_USER_REJECTED,
  CREATE_NAV_GROUP_START,
  CREATE_NAV_GROUP_FULFILLED,
  CREATE_NAV_GROUP_REJECTED,
  FETCH_NAV_GROUP_START,
  FETCH_NAV_GROUP_FULFILLED,
  FETCH_NAV_GROUP_REJECTED,
  UPDATE_NAV_GROUP_START,
  UPDATE_NAV_GROUP_FULFILLED,
  UPDATE_NAV_GROUP_REJECTED,
  DELETE_NAV_USERS_START,
  DELETE_NAV_USERS_FULFILLED,
  DELETE_NAV_USERS_REJECTED,
  DELETE_NAV_GROUPS_START,
  DELETE_NAV_GROUPS_FULFILLED,
  DELETE_NAV_GROUPS_REJECTED,
  ARCHIVE_NAV_USER_START,
  ARCHIVE_NAV_USER_FULFILLED,
  ARCHIVE_NAV_USER_REJECTED,
  UNARCHIVE_NAV_USER_START,
  UNARCHIVE_NAV_USER_FULFILLED,
  UNARCHIVE_NAV_USER_REJECTED,
  FETCH_NAV_WORKOUT_RESULTS_START,
  FETCH_NAV_WORKOUT_RESULTS_FULFILLED,
  FETCH_NAV_WORKOUT_RESULTS_REJECTED,
  FETCH_NAV_DAY_WORKOUT_ITEMS_START,
  FETCH_NAV_DAY_WORKOUT_ITEMS_FULFILLED,
  FETCH_NAV_DAY_WORKOUT_ITEMS_REJECTED,
  SET_IS_PREVIEW_CAROUSEL_SHOWING,
  BULK_UPDATE_GROUPS_START,
  BULK_UPDATE_GROUPS_FULFILLED,
  BULK_UPDATE_GROUPS_REJECTED,
  BULK_UPDATE_CALENDARS_START,
  BULK_UPDATE_CALENDARS_FULFILLED,
  BULK_UPDATE_CALENDARS_REJECTED,
  UPDATE_NAV_ATHLETE_IMAGE_START,
  UPDATE_NAV_ATHLETE_IMAGE_FULFILLED,
  UPDATE_NAV_ATHLETE_IMAGE_REJECTED,
  REMOVE_NAV_ATHLETE_IMAGE_START,
  REMOVE_NAV_ATHLETE_IMAGE_FULFILLED,
  REMOVE_NAV_ATHLETE_IMAGE_REJECTED,
  FETCH_NAV_COACHES_START,
  FETCH_NAV_COACHES_FULFILLED,
  FETCH_NAV_COACHES_REJECTED,
  FETCH_NAV_BLACKOUT_DATES_START,
  FETCH_NAV_BLACKOUT_DATES_FULFILLED,
  FETCH_NAV_BLACKOUT_DATES_REJECTED,
  CREATE_NAV_BLACKOUT_DATE_START,
  CREATE_NAV_BLACKOUT_DATE_FULFILLED,
  CREATE_NAV_BLACKOUT_DATE_REJECTED,
  DELETE_NAV_BLACKOUT_DATES_START,
  DELETE_NAV_BLACKOUT_DATES_FULFILLED,
  DELETE_NAV_BLACKOUT_DATES_REJECTED,
} from './actionTypes';

const initialState = {
  isLoadingAthletes: false,
  isLoadingArchivedAthletes: false,
  isLoadingAthleteCalendars: false,
  isLoadingAthletePrograms: false,
  isLoadingCalendars: false,
  isLoadingCalendarItems: false,
  isLoadingCalendarPreview: false,
  isLoadingGroups: false,
  isLoadingPrograms: false,
  isLoadingProgramItems: false,
  isLoadingProgramDayOne: false,
  isLoadingProgramPreview: false,
  isLoadingSelectedUser: false,
  isLoadingSelectedUserAssignments: false,
  isUpdatingSelectedUser: false,
  isCreatingUser: false,
  isCreatingGroup: false,
  isLoadingSelectedGroup: false,
  isUpdatingSelectedGroup: false,
  isRestartingAthleteProgram: false,
  isDeletingAthleteProgram: false,
  isDeletingUsers: false,
  isDeletingGroups: false,
  isArchivingUser: false,
  isUnarchivingUser: false,
  isAssigningAthletePrograms: false,
  isBulkUpdatingGroups: false,
  isBulkUpdatingCalendars: false,
  isLoadingWorkoutResults: false,
  isLoadingWorkoutsList: false,
  isPreviewCarouselShowing: false,
  isUpdatingAthleteImage: false,
  isLoadingCoaches: false,
  isLoadingBlackoutDates: false,
  isCreatingBlackoutDate: false,
  isDeletingBlackoutDates: false,
};

// eslint-disable-next-line default-param-last
export default function navigatorUIReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_NAV_ATHLETES_START:
      return {
        ...state,
        isLoadingAthletes: true,
      };
    case FETCH_NAV_ATHLETES_FULFILLED:
      return {
        ...state,
        isLoadingAthletes: false,
      };
    case FETCH_NAV_ATHLETES_REJECTED:
      return {
        ...state,
        isLoadingAthletes: false,
      };
    case FETCH_NAV_ARCHIVED_ATHLETES_START:
      return {
        ...state,
        isLoadingArchivedAthletes: true,
      };
    case FETCH_NAV_ARCHIVED_ATHLETES_FULFILLED:
      return {
        ...state,
        isLoadingArchivedAthletes: false,
      };
    case FETCH_NAV_ARCHIVED_ATHLETES_REJECTED:
      return {
        ...state,
        isLoadingArchivedAthletes: false,
      };
    case FETCH_NAV_ATHLETE_ASSIGNMENTS_START:
      return {
        ...state,
        isLoadingSelectedUserAssignments: true,
      };
    case FETCH_NAV_ATHLETE_ASSIGNMENTS_FULFILLED:
      return {
        ...state,
        isLoadingSelectedUserAssignments: false,
      };
    case FETCH_NAV_ATHLETE_ASSIGNMENTS_REJECTED:
      return {
        ...state,
        isLoadingSelectedUserAssignments: false,
      };
    case FETCH_NAV_ATHLETE_CALENDARS_START:
      return {
        ...state,
        isLoadingAthleteCalendars: true,
      };
    case FETCH_NAV_ATHLETE_CALENDARS_FULFILLED:
      return {
        ...state,
        isLoadingAthleteCalendars: false,
      };
    case FETCH_NAV_ATHLETE_CALENDARS_REJECTED:
      return {
        ...state,
        isLoadingAthleteCalendars: false,
      };
    case FETCH_NAV_ATHLETE_PROGRAMS_START:
      return {
        ...state,
        isLoadingAthletePrograms: true,
      };
    case FETCH_NAV_ATHLETE_PROGRAMS_FULFILLED:
      return {
        ...state,
        isLoadingAthletePrograms: false,
      };
    case FETCH_NAV_ATHLETE_PROGRAMS_REJECTED:
      return {
        ...state,
        isLoadingAthletePrograms: false,
      };
    case ASSIGN_NAV_ATHLETE_PROGRAMS_START:
      return {
        ...state,
        isAssigningAthletePrograms: true,
      };
    case ASSIGN_NAV_ATHLETE_PROGRAMS_FULFILLED:
      return {
        ...state,
        isAssigningAthletePrograms: false,
      };
    case ASSIGN_NAV_ATHLETE_PROGRAMS_REJECTED:
      return {
        ...state,
        isAssigningAthletePrograms: false,
      };
    case DELETE_NAV_ATHLETE_PROGRAM_START:
      return {
        ...state,
        isDeletingAthleteProgram: true,
      };
    case DELETE_NAV_ATHLETE_PROGRAM_FULFILLED:
      return {
        ...state,
        isDeletingAthleteProgram: false,
      };
    case DELETE_NAV_ATHLETE_PROGRAM_REJECTED:
      return {
        ...state,
        isDeletingAthleteProgram: false,
      };
    case RESTART_NAV_ATHLETE_PROGRAM_START:
      return {
        ...state,
        isRestartingAthleteProgram: true,
      };
    case RESTART_NAV_ATHLETE_PROGRAM_FULFILLED:
      return {
        ...state,
        isRestartingAthleteProgram: false,
      };
    case RESTART_NAV_ATHLETE_PROGRAM_REJECTED:
      return {
        ...state,
        isRestartingAthleteProgram: false,
      };
    case FETCH_NAV_CALENDARS_START:
      return {
        ...state,
        isLoadingCalendars: true,
      };
    case FETCH_NAV_CALENDARS_FULFILLED:
      return {
        ...state,
        isLoadingCalendars: false,
      };
    case FETCH_NAV_CALENDARS_REJECTED:
      return {
        ...state,
        isLoadingCalendars: false,
      };
    case FETCH_NAV_CALENDAR_ITEMS_START:
      return {
        ...state,
        isLoadingCalendarItems: true,
      };
    case FETCH_NAV_CALENDAR_ITEMS_FULFILLED:
      return {
        ...state,
        isLoadingCalendarItems: false,
      };
    case FETCH_NAV_CALENDAR_ITEMS_REJECTED:
      return {
        ...state,
        isLoadingCalendarItems: false,
      };
    case FETCH_NAV_CALENDAR_PREVIEW_START:
      return {
        ...state,
        isLoadingCalendarPreview: true,
      };
    case FETCH_NAV_CALENDAR_PREVIEW_FULFILLED:
      return {
        ...state,
        isLoadingCalendarPreview: false,
      };
    case FETCH_NAV_CALENDAR_PREVIEW_REJECTED:
      return {
        ...state,
        isLoadingCalendarPreview: false,
      };
    case FETCH_NAV_GROUPS_START:
      return {
        ...state,
        isLoadingGroups: true,
      };
    case FETCH_NAV_GROUPS_FULFILLED:
      return {
        ...state,
        isLoadingGroups: false,
      };
    case FETCH_NAV_GROUPS_REJECTED:
      return {
        ...state,
        isLoadingGroups: false,
      };
    case FETCH_NAV_PROGRAMS_START:
      return {
        ...state,
        isLoadingPrograms: true,
      };
    case FETCH_NAV_PROGRAMS_FULFILLED:
      return {
        ...state,
        isLoadingPrograms: false,
      };
    case FETCH_NAV_PROGRAMS_REJECTED:
      return {
        ...state,
        isLoadingPrograms: false,
      };
    case FETCH_NAV_PROGRAM_ITEMS_START:
      return {
        ...state,
        isLoadingProgramItems: true,
      };
    case FETCH_NAV_PROGRAM_ITEMS_FULFILLED:
      return {
        ...state,
        isLoadingProgramItems: false,
      };
    case FETCH_NAV_PROGRAM_ITEMS_REJECTED:
      return {
        ...state,
        isLoadingProgramItems: false,
      };
    case FETCH_NAV_PROGRAM_DAY_ONE_START:
      return {
        ...state,
        isLoadingProgramDayOne: true,
      };
    case FETCH_NAV_PROGRAM_DAY_ONE_FULFILLED:
      return {
        ...state,
        isLoadingProgramDayOne: false,
      };
    case FETCH_NAV_PROGRAM_DAY_ONE_REJECTED:
      return {
        ...state,
        isLoadingProgramDayOne: false,
      };
    case FETCH_NAV_PROGRAM_PREVIEW_START:
      return {
        ...state,
        isLoadingProgramPreview: true,
      };
    case FETCH_NAV_PROGRAM_PREVIEW_FULFILLED:
      return {
        ...state,
        isLoadingProgramPreview: false,
      };
    case FETCH_NAV_PROGRAM_PREVIEW_REJECTED:
      return {
        ...state,
        isLoadingProgramPreview: false,
      };
    case FETCH_NAV_USER_START:
      return {
        ...state,
        isLoadingSelectedUser: true,
      };
    case FETCH_NAV_USER_FULFILLED:
      return {
        ...state,
        isLoadingSelectedUser: false,
      };
    case FETCH_NAV_USER_REJECTED:
      return {
        ...state,
        isLoadingSelectedUser: false,
      };
    case UPDATE_NAV_USER_START:
      return {
        ...state,
        isUpdatingSelectedUser: true,
      };
    case UPDATE_NAV_USER_FULFILLED:
      return {
        ...state,
        isUpdatingSelectedUser: false,
      };
    case UPDATE_NAV_USER_REJECTED:
      return {
        ...state,
        isUpdatingSelectedUser: false,
      };
    case CREATE_NAV_USER_START:
      return {
        ...state,
        isCreatingUser: true,
      };
    case CREATE_NAV_USER_FULFILLED:
      return {
        ...state,
        isCreatingUser: false,
      };
    case CREATE_NAV_USER_REJECTED:
      return {
        ...state,
        isCreatingUser: false,
      };
    case CREATE_NAV_GROUP_START:
      return {
        ...state,
        isCreatingGroup: true,
      };
    case CREATE_NAV_GROUP_FULFILLED:
      return {
        ...state,
        isCreatingGroup: false,
      };
    case CREATE_NAV_GROUP_REJECTED:
      return {
        ...state,
        isCreatingGroup: false,
      };
    case FETCH_NAV_GROUP_START:
      return {
        ...state,
        isLoadingSelectedGroup: true,
      };
    case FETCH_NAV_GROUP_FULFILLED:
      return {
        ...state,
        isLoadingSelectedGroup: false,
      };
    case FETCH_NAV_GROUP_REJECTED:
      return {
        ...state,
        isLoadingSelectedGroup: false,
      };
    case UPDATE_NAV_GROUP_START:
      return {
        ...state,
        isUpdatingSelectedGroup: true,
      };
    case UPDATE_NAV_GROUP_FULFILLED:
      return {
        ...state,
        isUpdatingSelectedGroup: false,
      };
    case UPDATE_NAV_GROUP_REJECTED:
      return {
        ...state,
        isUpdatingSelectedGroup: false,
      };
    case DELETE_NAV_USERS_START:
      return {
        ...state,
        isDeletingUsers: true,
      };
    case DELETE_NAV_USERS_FULFILLED:
      return {
        ...state,
        isDeletingUsers: false,
      };
    case DELETE_NAV_USERS_REJECTED:
      return {
        ...state,
        isDeletingUsers: false,
      };
    case DELETE_NAV_GROUPS_START:
      return {
        ...state,
        isDeletingGroups: true,
      };
    case DELETE_NAV_GROUPS_FULFILLED:
      return {
        ...state,
        isDeletingGroups: false,
      };
    case DELETE_NAV_GROUPS_REJECTED:
      return {
        ...state,
        isDeletingGroups: false,
      };
    case ARCHIVE_NAV_USER_START:
      return {
        ...state,
        isArchivingUser: true,
      };
    case ARCHIVE_NAV_USER_FULFILLED:
      return {
        ...state,
        isArchivingUser: false,
      };
    case ARCHIVE_NAV_USER_REJECTED:
      return {
        ...state,
        isArchivingUser: false,
      };
    case UNARCHIVE_NAV_USER_START:
      return {
        ...state,
        isUnarchivingUser: true,
      };
    case UNARCHIVE_NAV_USER_FULFILLED:
      return {
        ...state,
        isUnarchivingUser: false,
      };
    case UNARCHIVE_NAV_USER_REJECTED:
      return {
        ...state,
        isUnarchivingUser: false,
      };
    case FETCH_NAV_WORKOUT_RESULTS_START:
      return {
        ...state,
        isLoadingWorkoutResults: true,
      };
    case FETCH_NAV_WORKOUT_RESULTS_FULFILLED:
      return {
        ...state,
        isLoadingWorkoutResults: false,
      };
    case FETCH_NAV_WORKOUT_RESULTS_REJECTED:
      return {
        ...state,
        isLoadingWorkoutResults: false,
      };
    case FETCH_NAV_DAY_WORKOUT_ITEMS_START:
      return {
        ...state,
        isLoadingWorkoutsList: true,
      };
    case FETCH_NAV_DAY_WORKOUT_ITEMS_FULFILLED:
      return {
        ...state,
        isLoadingWorkoutsList: false,
      };
    case FETCH_NAV_DAY_WORKOUT_ITEMS_REJECTED:
      return {
        ...state,
        isLoadingWorkoutsList: false,
      };
    case SET_IS_PREVIEW_CAROUSEL_SHOWING:
      return {
        ...state,
        isPreviewCarouselShowing: action.payload,
      };
    case BULK_UPDATE_GROUPS_START:
      return {
        ...state,
        isBulkUpdatingGroups: true,
      };
    case BULK_UPDATE_GROUPS_FULFILLED:
      return {
        ...state,
        isBulkUpdatingGroups: false,
      };
    case BULK_UPDATE_GROUPS_REJECTED:
      return {
        ...state,
        isBulkUpdatingGroups: false,
      };
    case BULK_UPDATE_CALENDARS_START:
      return {
        ...state,
        isBulkUpdatingCalendars: true,
      };
    case BULK_UPDATE_CALENDARS_FULFILLED:
      return {
        ...state,
        isBulkUpdatingCalendars: false,
      };
    case BULK_UPDATE_CALENDARS_REJECTED:
      return {
        ...state,
        isBulkUpdatingCalendars: false,
      };
    case UPDATE_NAV_ATHLETE_IMAGE_START:
      return {
        ...state,
        isUpdatingAthleteImage: true,
      };
    case UPDATE_NAV_ATHLETE_IMAGE_FULFILLED:
      return {
        ...state,
        isUpdatingAthleteImage: false,
      };
    case UPDATE_NAV_ATHLETE_IMAGE_REJECTED:
      return {
        ...state,
        isUpdatingAthleteImage: false,
      };
    case REMOVE_NAV_ATHLETE_IMAGE_START:
      return {
        ...state,
        isUpdatingAthleteImage: true,
      };
    case REMOVE_NAV_ATHLETE_IMAGE_FULFILLED:
      return {
        ...state,
        isUpdatingAthleteImage: false,
      };
    case REMOVE_NAV_ATHLETE_IMAGE_REJECTED:
      return {
        ...state,
        isUpdatingAthleteImage: false,
      };
    case FETCH_NAV_COACHES_START:
      return {
        ...state,
        isLoadingCoaches: true,
      };
    case FETCH_NAV_COACHES_FULFILLED:
      return {
        ...state,
        isLoadingCoaches: false,
      };
    case FETCH_NAV_COACHES_REJECTED:
      return {
        ...state,
        isLoadingCoaches: false,
      };
    case FETCH_NAV_BLACKOUT_DATES_START:
      return {
        ...state,
        isLoadingBlackoutDates: true,
      };
    case FETCH_NAV_BLACKOUT_DATES_FULFILLED:
      return {
        ...state,
        isLoadingBlackoutDates: false,
      };
    case FETCH_NAV_BLACKOUT_DATES_REJECTED:
      return {
        ...state,
        isLoadingBlackoutDates: false,
      };
    case CREATE_NAV_BLACKOUT_DATE_START:
      return {
        ...state,
        isCreatingBlackoutDate: true,
      };
    case CREATE_NAV_BLACKOUT_DATE_FULFILLED:
      return {
        ...state,
        isCreatingBlackoutDate: false,
      };
    case CREATE_NAV_BLACKOUT_DATE_REJECTED:
      return {
        ...state,
        isCreatingBlackoutDate: false,
      };
    case DELETE_NAV_BLACKOUT_DATES_START:
      return {
        ...state,
        isDeletingBlackoutDates: true,
      };
    case DELETE_NAV_BLACKOUT_DATES_FULFILLED:
      return {
        ...state,
        isDeletingBlackoutDates: false,
      };
    case DELETE_NAV_BLACKOUT_DATES_REJECTED:
      return {
        ...state,
        isDeletingBlackoutDates: false,
      };
    default:
      return state;
  }
}
